<template>
  <div class="brand" id="logo">
    <svg data-name="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 70" style="max-height: 100%;">
      <g class="small">
        <path fill="#D9E2EC" d="M9,11.7a1.91,1.91,0,0,1,1.53-.87h31.1s.08.07.12.07l7-5.38A9.82,9.82,0,0,0,41.58,3H10.48C4.79,3,0,6.91,0,12.72v6.82ZM43.17,23.6,43,44.47v5.69l-3.89-3.83H10.48c-1,0-1.06-.86-1.06-1.86V22.1L0,23.36V44.47c0,5.81,4.8,9.68,10.48,9.68H35.91L52,69l-.21-55.19Z" transform="translate(0 0.01)"></path>
        <path fill="#D9E2EC" d="M0,25.8,9,34V22L0,23.22Z" transform="translate(0 0.01)"></path>
        <path d="M25.92,42,0,23.42l7.63-6.75L26.18,30.05,59,0Z" transform="translate(0 0.01)"></path>
      </g>
      <g class="addon">
        <path d="M73.43,20.5H63v-7H91.4v7H81V48.09H73.43ZM85.82,34.89c0-7.57,5.33-13.8,13-13.8,8.77,0,12.78,6.87,12.78,14.39,0,.59,0,1.28-.1,2H93.21a6.1,6.1,0,0,0,6.42,5.19A8.55,8.55,0,0,0,106,39.93l4.26,3.81a13.06,13.06,0,0,1-10.72,4.94c-7.89,0-13.71-5.58-13.71-13.79Zm18.5-2.13c-.44-3.36-2.4-5.63-5.53-5.63s-5.09,2.22-5.68,5.63ZM114.9,21.59h7.44v3.76c1.72-2.23,3.92-4.26,7.69-4.26,5.63,0,8.91,3.76,8.91,9.84V48.09H131.5V33.31c0-3.56-1.66-5.39-4.51-5.39s-4.65,1.83-4.65,5.39V48.09H114.9ZM142,34.79c0-8.85,5.73-13.7,11.94-13.7a10,10,0,0,1,8.18,4V12h7.44V48.1h-7.44V44.29a9.64,9.64,0,0,1-8.18,4.3c-6.12,0-11.94-4.85-11.94-13.8Zm20.22,0c0-4.4-2.89-7.32-6.37-7.32s-6.41,2.87-6.41,7.42,2.94,7.32,6.41,7.32,6.37-2.92,6.37-7.42Zm9.55.1c0-7.57,5.34-13.8,13-13.8,8.77,0,12.78,6.87,12.78,14.39,0,.59-.05,1.28-.1,2H179.19a6.11,6.11,0,0,0,6.42,5.19A8.55,8.55,0,0,0,192,39.93l4.26,3.81a13.06,13.06,0,0,1-10.72,4.94c-7.88,0-13.71-5.58-13.71-13.79Zm18.51-2.13c-.44-3.36-2.4-5.63-5.54-5.63s-5.09,2.22-5.68,5.63Zm10.57-11.17h7.44v5.34c1.52-3.66,4-6,8.38-5.84V29h-.39c-4.95,0-8,3-8,9.34v9.79h-7.44V21.59Z" transform="translate(0 0.01)"></path>
        <path fill="silver" d="M213.27,48.09V43.45h4.6v4.64Zm8-25.56H225v5.14c2.06-3.06,5-5.68,9.7-5.68,6.07,0,12.09,4.84,12.09,13.35,0,8.35-6,13.3-12.09,13.3A11.42,11.42,0,0,1,225,43.2V56h-3.77Zm21.69,12.76c0-6-4.11-9.89-8.91-9.89s-9.15,4-9.15,9.94,4.45,9.89,9.15,9.89c4.9,0,8.91-3.66,8.91-9.94Zm7.64-12.76h3.77V29.2c1.86-4.25,5.54-7.32,10.34-7.12v4.1h-.3c-5.53,0-10,4-10,11.72V48.09h-3.77V22.53Zm13,12.81a13.2,13.2,0,1,1,13.12,13.35,13.06,13.06,0,0,1-13.12-13Zm22.52,0c0-5.49-4.06-10-9.4-10s-9.25,4.5-9.25,10,4,9.94,9.35,9.94S286.13,40.83,286.13,35.34Z" transform="translate(0 0.01)"></path>
      </g>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'Brand',
  components: {
  }
}
</script>

<style lang="scss">
.brand {
  font-size: 1.5rem;
  width: 120px;
  color: white;
  fill: #ff3214;
  height: 100%;
}
</style>
